/* eslint-disable prettier/prettier */
export const DEFAULT_COUNTRY_CODE = 'NL';
export const DEFAULT_LOCALE = 'nl-NL';
export const DEFAULT_THEME = 'facility';
export const MAX_ORDER_AGE_IN_DAYS = 30;
export const BREADCRUMBS_HOME_CODE = '-1';
export const DEFAULT_SHIPPING_COST = 15;
export const SHIPPING_METHOD_DELIVERY = '';
export const SHIPPING_METHOD_PICKUP = 'AFH-ENSCHE';
export const BLUR_IMAGE =
  // eslint-disable-next-line
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAAAAAA7VNdtAAADSklEQVRIx+1W2W4bMQwUqWPXNoKiRf//E1sgsffQxQ6ptWG0KZA+9C0KkrUljsghh9yQuH9d7D4h762/Z5LkfXtsE34+DBHpIkRM9FGI9NaakPee6WMQIEopnWOM72IeEHuSPnuv+5Y7pzlF5rE3zp4hovEjej3ucLKte/PTaY7B+NzP6AER3Wsd0TMDUWsGpA9I8ES4RIi9omhANBTcXBF98g488r5tRXyap5Ri0C2EGUCMhy9RurXlHffiWsKndV1LYx/TlKYpekGcjfEJLtkgiKnkArsWL5fke15v16WRDz5M8zxHbvl2K/50mmIKAW7YkloRy7Ks65ZzbbghlybmHMwKmK3Lsu04Ejk0Bkd6XvZ920utMIR3DVt39bYd20iPGMIgOEX+nd2O31wd6s4oPuGeWs0pLAf5O4Sxhk5Qk604H7CBwJtaY3VxavKAjBjEqahI6r5uRYNwjC9KyvyZwXAz+kUQ8ygES0HGbgvIlgIWCDJOc/ICinJvMQXqdT3M5/OcuO+vP3+8XpGl23UtwlG3Qy+5ylDaCEyQSxR/gpsYJL+9Xjdk/bpAAyjoPEXuUIc8BwbqmgQEHRKkFVRM0JrzE6oXtG9wq/zW+4xqW/b86cu3719fTimm+fJyTp7GaeAn8UvLy9uSezhdTr7v27qsuSJ9IUQVWeK23tbK6XxccEAgdkchRaq5gVjOzXnIGCr0IGfUeTo9QcqGijul13NxAcCSkXNotBQXkXi0i3MhzdE/xJ9rdziGCHOhNAXUCQn0ru5ZoF/yMbJDywSmQzBIL1LjqWtrwilKbimzD6I9qZlM5sP6ZShZCUD4aFCnGjV9aGKRB+QrJZ0CbK1MXTHO1K/toVNvDIPR56ZGFMwakkxlVBVj88I64pg2fbSGQcyQrYUBxte9q9xg083MjnV+3AfVkLwcukcGiJZmFHU5c82YKb2NcFu3znJyTDutlWczViK1GfluYjIeYxBa/2p+tNc0ohHpiHYsGjRBWllDlCpLb2u0JW0WhF1mGXQ6F4dsUQAEyzZhx0ylgJpSsexY6MesVqXrVxrD2uIDf/vDOjLb4Pb8zrjb2kMdy+PloOmk/ud78YCM1wQd1nS/hujzH5L/D/kFpqqYybdPYgcAAAAASUVORK5CYII=';
export const FALLBACK_IMAGE = '/-/jssmedia/Project/Tenants/CarelLurvink/shared/Logo/no-image.png';
export const HISTORY_STORAGE_KEY = '@cl/router-history';
export const GTM_QUEUE_STORAGE_KEY = '@cl/gmt_queue';
export const GRAPH_QL_ENDPOINT = (() => `${typeof window === 'undefined' ? process.env.URL_CD_INTERNAL : ''}/sitecore/api/graph/edge`)();
export const IS_SERVER = (() => typeof window === 'undefined')();
export const IS_CLIENT = (() => typeof window !== 'undefined')();

export const APP_ROUTES = {
  BLOG: '/blog',
  CATALOG: '/mijn-carel-lurvink/catalogus',
  CHECKOUT: '/afrekenen',
  CHECKOUT_SUCCESS: '/afrekenen/bedankt',
  CHECKOUT_LOGIN: '/afrekenen/login',
  CHECKOUT_GUEST_CHECKOUT: '/afrekenen/gast',
  DASHBOARD: '/mijn-carel-lurvink/dashboard',
  DELIVERY_ADDRESSES: '/mijn-carel-lurvink/beheer/afleveradressen',
  EMPLOYEES: '/mijn-carel-lurvink/beheer/medewerkers',
  INDEX: '/mijn-carel-lurvink',
  KNOWLEDGE_BASE: '/mijn-carel-lurvink/kenniscentrum',
  LOGIN: '/login',
  LOGOUT: '/handlers/logoff.ashx',
  FORGOT_PASSWORD: '/wachtwoord-vergeten',
  REGISTER: '/registreren',
  MANAGE: '/mijn-carel-lurvink/beheer/mijn-account',
  MY_ACCOUNT: '/mijn-carel-lurvink/beheer/mijn-account',
  ORDERLISTS: '/mijn-carel-lurvink/beheer/bestellijsten',
  ORDER_HISTORY: '/mijn-carel-lurvink/bestelgeschiedenis',
  SHIPMENTS: '/mijn-carel-lurvink/bestelgeschiedenis/verzendingen',
  INVOICES: '/mijn-carel-lurvink/bestelgeschiedenis/facturen',
  RETURNS: '/mijn-carel-lurvink/bestelgeschiedenis/retouren',
  RETURNS_REGISTER: '/mijn-carel-lurvink/bestelgeschiedenis/retouren/aanmelden',
  SHOPPINGCART: '/winkelwagen',
  SHOPPINGCART_OCI: '/mt-api/checkout/oci',
  WEBSHOP: '/webshop'
};

export const FEATURE_TOGGLES = {
  CATALOG: 'mcl:catalog',
  CATALOG_PRODUCT_DETAILS: 'mcl:catalog_product_details',
  RETURNS: 'mcl:returns'
} as const;

export const PRODUCT = {
  NOT_IN_STOCK_CODES: ['WEBSERV', 'NIETLEV'],
  VARIANT_TYPE_COLOR: '1400',
  VARIANT_TYPE_SIZE: '1300',
  VARIANT_TYPE_MATERIAL: '1500',
  VARIANT_TYPE_BRAND: '1100',
  PRODUCT_STATUS_PUBLIC: ''
} as const;

export const ENV = (() => {
  if (typeof window !== 'undefined') {
    // @ts-expect-error: env not on window
    return window?.env ?? [];
  }

  return process?.env ?? [];
})();

export const APP_SECTORS = {
  FACILITY: 'Facility',
  MEDICAL: 'Medical',
  INDUSTRY: 'Industry',
  FOOD: 'Food'
};

export enum APP_SECTORS_CODES {
  FACILITY = '40INST',
  MEDICAL = '30MED',
  INDUSTRY = '20IND',
  FOOD = '10FOODPHARM'
}
